export default __webpack_public_path__ + "static/media/PSOVWaterQuantTemplate.e6dbbf3e.xlsx";